/* global angular, $, _
 */
angular.module('ua5App')
    .directive('resourceConnectform', ['$state', '$timeout', '$rootScope', '$sce', 'FormsFactory', function($state, $timeout, $rootScope, $sce, FormsFactory) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-connectform/resource-connectform.html',
            scope: {
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {
                var contactFields = [
                    'nameFirst',
                    'nameMiddle',
                    'nameLast',
                    'nameOther',

                    'email',

                    'addressStreet1',
                    'addressStreet2',
                    'addressCity',
                    'addressState',
                    'addressZip',
                    'addressCountry',
                    'phoneHome',
                    'phoneMobile',

                    'businessTitle',
                    'businessCompany',
                    'businessField',
                    'businessStreet1',
                    'businessStreet2',
                    'businessCity',
                    'businessState',
                    'businessZip',
                    'businessCountry',
                    'businessPhone',
                    'businessEmail',

                    'website'
                ];

                var accomplishmentFields = [
                    'name_first',
                    'name_last',

                    'accomplishments',

                    'experienceHighlights',
                    'experienceMentors',
                    'experienceStudy',

                    'experienceAfter',
                    'experienceDoors',
                    'experienceKnowledge',

                    'comments',

                    'workLinks'
                ];

                $scope.inputFocus = {};
                for (var i = 0; i< contactFields.length; i++) {
                    $scope.inputFocus[contactFields[i]] = false;
                }

                for (i = 0; i< accomplishmentFields.length; i++) {
                    $scope.inputFocus[accomplishmentFields[i]] = false;
                }

                // resize fields to fit
                $('.resource-connectform').find('label').each(function() {
                    if (!$(this).hasClass('resources-connectform__label-long')) {
                        var w = $(this).width();
                        $(this).next().css('text-indent', w + 20 + 'px');
                    }
                });

                $('label', element).click(function() {
                    var labelID = $(this).attr('for');
                    $('#' + labelID).trigger('click');
                });

                $scope.submitContact = function() {
                    var cForm = $scope.contactForm;
                    if ($scope.contactForm.$invalid) {
                        alert('Please fill in the required fields above.');
                    } else {
                        console.log('submit form logic here');
                        FormsFactory.contact({
                            firstname: cForm.nameFirst.$modelValue,
                            middlename: cForm.nameMiddle.$modelValue,
                            lastname: cForm.nameLast.$modelValue,
                            othername: cForm.nameOther.$modelValue,
                            email: cForm.email.$modelValue,
                            address1: cForm.addressStreet1.$modelValue,
                            address2: cForm.addressStreet2.$modelValue,
                            city: cForm.addressCity.$modelValue,
                            state: cForm.addressState.$modelValue,
                            zip: cForm.addressZip.$modelValue,
                            country: cForm.addressCountry.$modelValue,
                            phone: cForm.phoneHome.$modelValue,
                            cell: cForm.phoneMobile.$modelValue,
                            company: cForm.businessCompany.$modelValue,
                            position: cForm.businessTitle.$modelValue,
                            field: cForm.businessField.$modelValue,
                            // jscs:disable
                            'bus_address1': cForm.businessStreet1.$modelValue,
                            'bus_address2': cForm.businessStreet2.$modelValue,
                            'bus_city': cForm.businessCity.$modelValue,
                            'bus_zip': cForm.businessZip.$modelValue,
                            'bus_country': cForm.businessCountry.$modelValue,
                            'bus_email': cForm.businessEmail.$modelValue,
                            'bus_phone': cForm.businessPhone.$modelValue,
                            // jscs:enable
                            url: cForm.website.$modelValue
                        }).then(function(response) {
                            if (response.data && response.data.Errors) {
                                // error handling
                                alert(response.data.Errors.join('\n'));
                            } else if (response.data) {
                                // success;
                                alert('Thank you for submitting your information!');
                                $('.hasForm .openFormLink', element).click();
                            } else {
                                // unknown error
                                alert('An error occured, please try submitting your form again.');
                            }
                        });
                    }
                };

                $scope.submitAccomplishments = function() {

                    var aForm = $scope.accomplishmentsForm;
                    var fieldsCompleted = 0;
                    if ($scope.accomplishments) {
                        _.each($scope.accomplishments, function(value, key) {
                            if (value && value.trim() !== '') {
                                fieldsCompleted++;
                            }
                        });
                    }

                    if (fieldsCompleted < 1) {
                        alert('Please fill in at least one field');
                    } else {
                        FormsFactory.accomplishments({
                            // jscs:disable
                            'name_first': aForm.nameFirst.$modelValue,
                            'name_last': aForm.nameLast.$modelValue,
                            // jscs:enable
                            recent: aForm.accomplishments.$modelValue,
                            highlights: aForm.experienceHighlights.$modelValue,
                            relationships: aForm.experienceMentors.$modelValue,
                            enhancements: aForm.experienceStudy.$modelValue,
                            doors: aForm.experienceDoors.$modelValue,
                            experience: aForm.experienceAfter.$modelValue,
                            advice: aForm.experienceKnowledge.$modelValue,
                            comments: aForm.comments.$modelValue,
                            links: aForm.workLinks.$modelValue
                        }).then(function(response) {
                            if (response.data && response.data.Errors) {
                                // error handling
                                alert(response.data.Errors.join('\n'));
                            } else if (response.data) {
                                // success;
                                alert('Thank you for submitting your accomplishments!');
                                $('.hasForm .openFormLink', element).click();
                            } else {
                                // unknown error
                                alert('An error occured, please try submitting your form again.');
                            }
                        });
                    }
                };

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                });
            }
        };
    }])
;
